exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__payment-card-background___10n7N{position:absolute;top:0;bottom:0;left:0;right:0}.styles__payment-card-background___10n7N .styles__svg-background___2xHew{position:relative;width:100%;height:100%}.styles__payment-card-background___10n7N .styles__svg-background___2xHew.styles__triangles___9YDVq>svg{opacity:.4;top:-25%}.styles__payment-card-background___10n7N .styles__svg-background___2xHew.styles__worldMap___5FdWp>svg{top:-40%;opacity:.6}.styles__payment-card-background___10n7N .styles__svg-background___2xHew.styles__spiral___19a_i>svg{top:0;height:100%;width:auto;opacity:.5}.styles__payment-card-background___10n7N svg{position:relative;width:100%;fill:#ecf0f1}", ""]);

// exports
exports.locals = {
	"payment-card-background": "styles__payment-card-background___10n7N",
	"svg-background": "styles__svg-background___2xHew",
	"triangles": "styles__triangles___9YDVq",
	"worldMap": "styles__worldMap___5FdWp",
	"spiral": "styles__spiral___19a_i"
};